KXL.module('GamesApp.Masthead', function (Masthead, KXL, Backbone, Marionette, $, _) {
	Masthead.View = Marionette.ItemView.extend({
		template: '#kx-masthead',
		className: 'kx-masthead',
		serializeData: function () {
			return this.options;
		}
	})
});
